import React, { useState } from 'react';
import ProductDetailDescriptionTab from "./ProductDetailDescriptionTab";
import ProductDetailAlternativeTab from "./ProductDetailAlternativeTab";
import ProductDetailDocumentTab from "./ProductDetailDocumentTab";
import useReduxState from "../../../../hooks/useReduxState";
import Helper from "../../../../helper/Helper";
import { useProductStore } from 'src/hooks/product';
import ProductCompareMiniSlider from 'src/pages/ProductCompare/BottomCompareProduct/ProductCompareMiniSlider';
import PDPSellingProduct from '../PDPSellingProduct';

const ProductDetailTabs = (props) => {
    const { productDetail } = props
    const [{ alternative_product_count, product_document_data }, { }, { }] = useProductStore();
    const [alt_product_API_call, set_alt_product_API_call] = useReduxState(false, 'alt_product_API_call');
    const [product_document_API_call, set_product_document_API_call] = useReduxState(false, 'product_document_API_call');
    const [data, setData] = useState("#tab1");
    const setActiveTab = (e) => {
        setData(e.currentTarget.attributes.href.value);
    };

    return (
        <>
            <div className="product-detail-tab-area">
                {/* Nav tabs */}
                <ul className="bs5 nav nav-tabs dark-tabs nav-justified mob-tabs-row m-t-20">
                    <li className="bs5 nav-item active">
                        <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab1"
                            onClick={(e) => setActiveTab(e)}><h2 className='m-0 font-13'>Description</h2></a>
                    </li>
                    {
                        alternative_product_count > 0 &&
                        <li className="bs5 nav-item">
                            <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab2"
                                onClick={(e) => {
                                    setActiveTab(e)
                                    set_alt_product_API_call(Helper.UUID())
                                }}><h2 className='m-0 font-13'>Subs/Alternatives({alternative_product_count})</h2></a>
                        </li>
                    }
                    {
                        product_document_data?.Count > 0 &&
                        <li className="bs5 nav-item">
                            <a className="bs5 nav-link text-none" data-toggle="tab" href="#tab3"
                                onClick={(e) => {
                                    setActiveTab(e)
                                    set_product_document_API_call(Helper.UUID())
                                }}><h2 className='m-0 font-13'>Documents({product_document_data?.Count})</h2></a>
                        </li>
                    }
                </ul>
                {/* Tab panes */}
                <div className="tab-content px-0 border-0 mob-tab-content pt-3 mt-0">

                    <ProductDetailDescriptionTab activeTab={data} productDetail={productDetail} />

                    <ProductDetailAlternativeTab activeTab={data} productDetail={productDetail} />

                    <ProductDetailDocumentTab activeTab={data} productDetail={productDetail} />
                    <PDPSellingProduct productDetail={productDetail} />
                    <ProductCompareMiniSlider />
                </div>
            </div>
        </>
    );
}

export default ProductDetailTabs;